module.exports = __webpack_public_path__ + "media/images/admin/icons/github-e7ab8675a2cbadea548cafe724065b9e.svg";